import React from 'react';

import { RouterProps } from 'app/constants/PropType/propTypesRouter';

import PropType from 'prop-types';
import './switch.css';

import { Button } from 'antd';

import { useSelector } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { UnorderedListOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { pageScope } from 'app/constants/mapConstants';
import withTranslations from 'app/components/HOGs/withTranslations';
import { history } from '../../../store';
import { isEmptyObject, isListExists } from '../../Utility/utility';

const SwitchMapList = (props) => {
  const { tr } = props;
  const admin = useSelector((store) => store.clubFullDataReducer.admin);
  const placesData = useSelector((store) => store.placesData.data);
  const getUrlIfFromClub = () => {
    return admin ? { prevUrl: props.router.location.pathname } : {};
  };

  const urlScope = props.router.location.pathname.split('/')[1];

  const getText =
    urlScope === pageScope.place ? tr['Create place'] : tr['Create tour'];

  const url = props.router.location.pathname.split('/').slice(0, -1).join('/');

  const getExtBtn = () => {
    if (urlScope === pageScope.place && isEmptyObject(placesData)) {
      return (
        <Button
          className="createTourBtn"
          size="large"
          icon={<PlusCircleOutlined />}
          style={{ margin: '10px 10px 10px 0px', height: 35, fontSize: 14 }}
          onClick={() => history.push('/createtour', getUrlIfFromClub())}
        >
          <span style={{ textTransform: 'uppercase' }}>
            {tr['Create tour']}
          </span>
        </Button>
      );
    }
    return null;
  };

  const getUrl = urlScope === pageScope.place ? '/place/create' : '/createtour';

  return (
    <div className="mainLayoutSwitchBtn">
      <Button
        className="createTourBtn"
        type="primary"
        size="large"
        icon={<PlusCircleOutlined />}
        style={{ margin: 10, height: 35, fontWeight: 'bold', fontSize: 14 }}
        onClick={() => history.push(getUrl, getUrlIfFromClub())}
      >
        <span style={{ textTransform: 'uppercase' }}>{getText}</span>
      </Button>
      <Button
        className="show-list-button"
        size="large"
        style={{ margin: 10, height: 35, fontSize: 14 }}
        onClick={() => {
          if (!isListExists(props.router)) {
            if (props.router.location.pathname === '/') {
              history.push('/list');
            } else {
              history.push(`${props.router.location.pathname}/list`);
            }
          } else {
            history.push(url);
          }
        }}
      >
        <UnorderedListOutlined />
        <span style={{ textTransform: 'uppercase' }}>
          <FormattedMessage id="List" defaultMessage="List" />
        </span>
      </Button>
      {getExtBtn()}
    </div>
  );
};

SwitchMapList.propType = {
  router: PropType.shape(RouterProps),
};
export default withTranslations(SwitchMapList);
